// ============================================================
//  COPIE ESTE ARQUIVO INTEIRO para: src/components/Navbar.jsx
//  Depois importe em qualquer página com:
//  import Navbar from '../components/Navbar';
//  E use: <Navbar />
// ============================================================

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Fecha menu mobile ao navegar
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { label: 'Como Funciona', path: '/como-funciona' },
    { label: 'Planos',        path: '/planos' },
    { label: 'FAQ',           path: '/faq' },
  ];

  return (
    <>
      <nav
        className={`sticky top-0 z-50 bg-white border-b border-gray-100 transition-shadow duration-200 ${
          scrolled ? 'shadow-sm' : ''
        }`}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">

          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 flex-shrink-0"
            aria-label="Ir para a página inicial"
          >
            <img src="/lembrou-logo-png.png" alt="Lembrou?" className="h-8" />
          </button>

          {/* Links — desktop */}
          <div className="hidden sm:flex items-center gap-1">
            {navLinks.map(({ label, path }) => (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  isActive(path)
                    ? 'text-primary bg-red-50'
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                {label}
              </button>
            ))}
          </div>

          {/* Ações — desktop */}
          <div className="hidden sm:flex items-center gap-2">
            <div className="w-px h-5 bg-gray-200 mr-1" aria-hidden="true" />
            <button
              onClick={() => navigate('/auth?mode=business')}
              className="px-4 py-2 text-sm font-semibold text-gray-500 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-colors"
            >
              Entrar
            </button>
            <button
              onClick={() => navigate('/auth?mode=business')}
              className="flex items-center gap-2 px-5 py-2 bg-primary hover:bg-primary-hover text-white text-sm font-bold rounded-lg transition-colors"
            >
              Começar Grátis
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M2.5 7H11.5M7.5 3L11.5 7L7.5 11" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          {/* Hamburguer — mobile */}
          <div className="sm:hidden flex items-center gap-2">
            <button
              onClick={() => navigate('/auth?mode=business')}
              className="flex items-center gap-1 px-4 py-2 bg-primary hover:bg-primary-hover text-white text-sm font-bold rounded-lg transition-colors"
            >
              Começar Grátis →
            </button>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
              aria-expanded={menuOpen}
              className="p-2 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="flex flex-col gap-1.5">
                <span className="block w-5 h-0.5 bg-gray-700 rounded" />
                <span className="block w-5 h-0.5 bg-gray-700 rounded" />
                <span className={`block h-0.5 bg-gray-700 rounded transition-all ${menuOpen ? 'w-5' : 'w-3.5'}`} />
              </div>
            </button>
          </div>

        </div>
      </nav>

      {/* Menu mobile */}
      {menuOpen && (
        <div className="sm:hidden fixed top-16 left-0 right-0 z-40 bg-white border-b border-gray-100 shadow-lg px-4 py-4 flex flex-col gap-1">
          {navLinks.map(({ label, path }) => (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`w-full text-left px-4 py-3 rounded-lg text-sm font-semibold transition-colors ${
                isActive(path)
                  ? 'text-primary bg-red-50'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              {label}
            </button>
          ))}
          <div className="border-t border-gray-100 mt-2 pt-3 flex gap-2">
            <button
              onClick={() => navigate('/auth?mode=business')}
              className="flex-1 py-2.5 text-sm font-semibold text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Entrar
            </button>
            <button
              onClick={() => navigate('/auth?mode=business')}
              className="flex-2 flex-grow py-2.5 px-4 text-sm font-bold text-white bg-primary hover:bg-primary-hover rounded-lg transition-colors"
            >
              Começar Grátis →
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
